import React from 'react';

import './Edge.scss';
import { EdgeType, NodeType } from './models';

interface EdgeProps {
  edge: EdgeType;
  nodes: NodeType[];
}

const Edge: React.FC<EdgeProps> = ({
  edge,
  nodes,
}) => {
  const source = nodes.find((n: NodeType) => n.id === edge.source);
  const target = nodes.find((n: NodeType) => n.id === edge.target);
  if (!source || !target) return null;

  return (
    <line
      key={edge.id}
      x1={source.position.x + 80}
      y1={source.position.y + 20}
      x2={target.position.x}
      y2={target.position.y + 20}
      className="workflow-edge"
      markerEnd="url(#arrow)"
    />
  );
};

export default Edge; 